const CART_URL =
  'https://www.mensajesmagneticospro.com/cart/add?id=48021977792740&quantity=1'

const EVENT_PARAMS = {
  content_name: 'Mensajes Magnéticos',
  content_type: 'product',
}

/**
 * Fires AddToCart + InitiateCheckout events, then redirects to Shopify cart.
 * Uses a short delay to ensure pixel events are sent before navigation.
 */
export function handleCartClick(e: React.MouseEvent<HTMLAnchorElement>) {
  e.preventDefault()
  const fbq = (window as any).fbq
  if (fbq) {
    fbq('track', 'AddToCart', EVENT_PARAMS)
    fbq('track', 'InitiateCheckout', EVENT_PARAMS)
  }
  // Small delay to allow pixel events to fire before redirect
  setTimeout(() => {
    window.location.href = CART_URL
  }, 300)
}

export { CART_URL }
